import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import {
  ContentfulRichTextGatsbyReference,
  renderRichText,
  RenderRichTextData,
} from 'gatsby-source-contentful/rich-text'
import React from 'react'
import { classNames } from '../utils'
import { H3, H4 } from './Typography'

interface ValuePropImageProps {
  title?: string
  description?: Partial<RenderRichTextData<ContentfulRichTextGatsbyReference>>
  imageFile?: IGatsbyImageData
  imageTitle?: string
  reverse?: boolean
}

export const ValuePropImage = ({
  title,
  description,
  imageFile,
  imageTitle,
  reverse,
}: ValuePropImageProps) => {
  return (
    <section
      className={classNames(
        'grid grid-cols-12 rounded-2xl px-8 md:px-0',
        reverse ? 'py-10' : 'pb-5 pt-15'
      )}
    >
      <div
        className={classNames(
          reverse
            ? 'col-span-12 row-start-1 md:col-start-7 md:col-end-13'
            : 'col-span-12 pl-8 md:col-start-1 md:col-end-7',
          'flex flex-col justify-center'
        )}
      >
        <h2
          className={classNames(
            `header-highlight relative mb-8 pl-m text-xxxl font-bold leading-normal text-default-50`
          )}
        >
          {title}
        </h2>
        <H4 customClasses="text-default-darker">
          {renderRichText(description)}
        </H4>
      </div>
      <GatsbyImage
        className={classNames(
          reverse
            ? 'col-span-12 md:col-start-1 md:col-end-7'
            : 'col-span-12 md:col-start-7 md:col-end-13',
          'h-104'
        )}
        imgStyle={{
          objectPosition: reverse ? 'center left' : 'center right',
        }}
        objectFit="contain"
        image={imageFile}
        alt={imageTitle}
      />
    </section>
  )
}
